import { PatientSummaryDto } from '../../../types/swaggerTypes'

type RecordTreatmentEligibility = Pick<
  PatientSummaryDto,
  'openVialsFlag' | 'stockOrderFlag' | 'programSupportsReconciliation'
>

export const canRecordTreatment = (
  patient: RecordTreatmentEligibility | null | undefined
): boolean => {
  if (!patient) {
    return false
  }

  return (
    Boolean(patient.openVialsFlag) &&
    !patient.stockOrderFlag &&
    patient.programSupportsReconciliation !== false
  )
}
